module.exports = __webpack_public_path__ + "static/img/action-icon4.8392b5e1.png";